import { render } from "./CompaniesListView.vue?vue&type=template&id=961c4f9a&scoped=true&ts=true"
import script from "./CompaniesListView.vue?vue&type=script&lang=ts"
export * from "./CompaniesListView.vue?vue&type=script&lang=ts"

import "./CompaniesListView.vue?vue&type=style&index=0&id=961c4f9a&scoped=true&lang=css"
import "./CompaniesListView.vue?vue&type=style&index=1&id=961c4f9a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961c4f9a"]])

export default __exports__